import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/globalGallery',
            name: 'village_globalGallery',
            component: () => import("./views/globalGallery.vue"),
            meta: {
                hideTopCut: true,
                showMembership: false,
            }
        },
        {
            path: '/village/galleryItemsBought',
            name: 'village_galleryItemsBought',
            component: () => import("./views/galleryItemsBought.vue"),
            meta: {
                hasBar: false,
                hideTopCut: false,
                showMembership: false,
            }
        },
    ];
};